import { mapActions, mapGetters } from 'vuex';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      isCategoriesLabelVisible: false,
      swiperOption: {
        roundLengths: true, // Fixes blurry text
        slidesPerView: 8,
        breakpoints: {
          320: { // iPhone 5
            slidesPerView: 3.5,
          },
          640: {
            slidesPerView: 4.5,
          },
          1024: {
            slidesPerView: 6.5,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters('browse', ['userBrowseHeaders']),
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    externalBrowseHeaders() {
      return this.userBrowseHeaders.filter(item => item.external);
    },
    categoryBrowseHeaders() {
      return this.userBrowseHeaders.filter(item => !item.external);
    },
    categoriesIcon() {
      // if (this.isLayoutDesktop) {
      //   return this.iconClassModifiers({ icon: 'globe' });
      // }
      return this.iconClassModifiers({ icon: 'categories' });
    },
    isAllMarketsLinkActive() {
      return this.$route.name === 'market-list' && !this.$route.params.headerId;
    },
    classModifiers() {
      return {
        'nav-browse': true,
        'nav-browse--desktop': !this.isLayoutMobile,
        'nav-browse--mobile': this.isLayoutMobile,
      };
    },
  },
  methods: {
    ...mapActions('browse', ['toggleNavBrowseCategoriesOverlay']),
    toggleCategoriesLabel() {
      if (this.isLayoutMobile) {
        this.toggleNavBrowseCategoriesOverlay();
      }
    },
    iconClassModifiers(item) {
      return {
        'nav-browse__link-icon': true,
        [`nav-browse__link-icon--${item.icon}`]: item.icon,
      };
    },
  },
  mounted() {
    if (this.isLayoutDesktop) {
      this.isCategoriesLabelVisible = true;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-secondary-nav/nav-browse/nav-browse.js